import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../LanguageContext';
import { Grid, Typography, useTheme, Box, Button } from '@mui/material';

const DesktopHeader = ({ headerLinks, languages }) => {
	const { changeLocale } = useLanguage();
	const intl = useIntl();
	const theme = useTheme();

	return (
		<Grid
			container
			gap={2}
			justifyContent={'space-between'}
			width={'100%'}
			height={80}
			bgcolor={theme.palette.primary.one}
			boxShadow={5}
			px={'9.3%'}
		>
			<Box
				px={'45px'}
				py={'20px'}
				bgcolor={theme.palette.secondary.one}
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<img
					src="/assets/Images/AltynLogo.svg"
					alt="AltynLogoImg"
					width="100%"
					height="100%"
				/>
			</Box>
			<Box
				display={'flex'}
				gap={'24px'}
				alignItems={'center'}
				height={'max-content'}
				pt={'25px'}
			>
				{headerLinks.map(({ link, title }) => (
					<NavLink
						key={title}
						to={link}
					>
						{({ isActive }) => (
							<Typography
								color={theme.palette.secondary.one}
								fontSize={isActive ? 20 : 16}
								fontWeight={isActive ? 900 : 500}
							>
								{intl.$t({ id: title })}
							</Typography>
						)}
					</NavLink>
				))}
			</Box>
			<Box
				display={'flex'}
				gap={'10px'}
				alignItems={'center'}
				height={'max-content'}
				pt={'25px'}
			>
				{languages?.map(({ title, symbol, id }, index) => (
					<Button
						key={index}
						style={{
							backgroundColor:
								localStorage.getItem('userLocale') === id
									? 'rgba(68, 74, 93, 1)'
									: 'rgba(255, 191, 63, 1)',
							color:
								localStorage.getItem('userLocale') === id
									? 'white'
									: 'rgba(68, 74, 93, 1)',
							border:
								localStorage.getItem('userLocale') === id
									? 'none'
									: '1px solid rgba(68, 74, 93, 1)',
							minWidth: '24px',
							height: '20px',
							padding: '0px',
							display: 'flex',
							alignItems: 'flex-start',
							justifyContent: 'center',
							borderRadius: '3px',
							margin: 'auto',
							fontSize: '12px',
						}}
						onClick={() => {
							changeLocale(symbol);
						}}
					>
						{title}
					</Button>
				))}
			</Box>
		</Grid>
	);
};

export default DesktopHeader;
